import { call, put, takeLatest } from 'redux-saga/effects';
import {
  LOAD_TEMPLATE_CONTENT,
  LOAD_TEMPLATE_CONTENT_SUCCESS,
} from './constants';
import templateService from '~/services/templateService';

function* loadTemplateContent(action) {
  const { page, role, lang } = action.payload;
  try {
    const { templates, total, numberPages, page: currentPage } = yield call(
      templateService.listTemplatesForHomePage,
      {
        max_results: 1,
        role: role || 'user',
        lang: lang || 'ja',
      },
    );
    templates.forEach((cat) =>
      cat.items.forEach((item) => {
        try {
          item.titles = JSON.parse(item.title);
          item.title = item.titles['title_original'];
        } catch (err) {
          item.titles = item.title;
        }
      }),
    );
    yield put({
      type: LOAD_TEMPLATE_CONTENT_SUCCESS,
      payload: {
        templates,
      },
    });
  } catch (error) {
    console.log(error);
  }
}

export default function* homeSaga() {
  yield takeLatest(LOAD_TEMPLATE_CONTENT, loadTemplateContent);
}
